import React from 'react';
import {
    BrowserRouter as Router,
    Switch,
    Route,
} from "react-router-dom";
import logo from './assets/images/logo.png';
import Validate from './screens/validate/Validate';
import Nursery from './screens/nursery/Nursery';
import Treatment from './screens/treatment/Treatment';
import Home from './screens/home/Home';

function App() {
    return (
        <Router>
            <header>
                <img src={logo} alt="Plant Protection Organization" className="logo" />
                <div>
                    <h1>سازمان حفظ نباتات کشور</h1>
                    <h1>Plant Protection Organization</h1>
                </div>
            </header>
            <main>
                <Switch>
                    <Route path="/phytosanitary">
                        <Validate />
                    </Route>
                    <Route path="/nursery">
                        <Nursery />
                    </Route>
                    <Route path="/treatment">
                        <Treatment />
                    </Route>
                    <Route path="/">
                        <Home />
                    </Route>
                </Switch>
            </main>
        </Router>
    );
}

export default App;
